// react
import React, { useEffect, useState } from 'react';

// custom components
import ProductCard from './product-card';

// styles
import { Spacing, Colors } from '_styles';

// format cards in grid style
const styles = {
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: Spacing.SCALE_20,
        padding: Spacing.SCALE_20,
    }
};

const ProductList = (props) => {

    return (
        <div style={styles.grid}>
            {props.products.map((product) => (
                <ProductCard key={product.id} product={product} />
            ))}
        </div>
    );
};

export default ProductList;
